import React, { useEffect, useState } from "react";
import { CalendarDays, ChevronLeft, ChevronRight, Gift, Cake, Palmtree, Star } from "lucide-react";
import api from "../lib/api";
import { PageHeader, Card, Loading, EmptyState } from "../components/ui";

const MONTHS = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const ICON = { HOLIDAY: Star, BIRTHDAY: Cake, ANNIVERSARY: Gift, LEAVE: Palmtree };

export default function Calendar() {
  const now = new Date();
  const [m, setM] = useState(now.getMonth() + 1);
  const [y, setY] = useState(now.getFullYear());
  const [data, setData] = useState(null);

  useEffect(() => { setData(null); api.get(`/calendar?month=${m}&year=${y}`).then(({ data }) => setData(data)); }, [m, y]);
  const nav = (d) => { let nm = m + d, ny = y; if (nm > 12) { nm = 1; ny++; } if (nm < 1) { nm = 12; ny--; } setM(nm); setY(ny); };

  const byDay = {};
  (data?.events || []).forEach((e) => { const day = new Date(e.date).getDate(); (byDay[day] = byDay[day] || []).push(e); });

  return (
    <div>
      <PageHeader title="HR Calendar" subtitle="Holidays, birthdays, work anniversaries & leaves" />
      <div className="mb-5 flex items-center gap-3">
        <button data-testid="cal-prev" onClick={() => nav(-1)} className="rounded-lg border border-slate-200 p-2 hover:bg-slate-50 dark:border-slate-700 dark:hover:bg-slate-800"><ChevronLeft size={16} /></button>
        <span className="font-head text-lg font-bold text-slate-800 dark:text-white">{MONTHS[m - 1]} {y}</span>
        <button data-testid="cal-next" onClick={() => nav(1)} className="rounded-lg border border-slate-200 p-2 hover:bg-slate-50 dark:border-slate-700 dark:hover:bg-slate-800"><ChevronRight size={16} /></button>
      </div>
      {!data ? <Loading /> : data.events.length === 0 ? <EmptyState icon={CalendarDays} title="No events this month" /> : (
        <div className="space-y-3" data-testid="calendar-events">
          {Object.keys(byDay).map(Number).sort((a, b) => a - b).map((day) => (
            <Card key={day} className="flex gap-4 p-4" data-testid={`cal-day-${day}`}>
              <div className="flex h-14 w-14 shrink-0 flex-col items-center justify-center rounded-xl bg-accent/10">
                <span className="font-head text-xl font-extrabold text-accent">{day}</span>
                <span className="text-[10px] uppercase text-slate-400">{MONTHS[m - 1].slice(0, 3)}</span>
              </div>
              <div className="flex flex-1 flex-wrap items-center gap-2 py-1">
                {byDay[day].map((e, i) => { const I = ICON[e.type] || Star; return (
                  <span key={i} className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium" style={{ backgroundColor: e.color + "1a", color: e.color }}>
                    <I size={12} /> {e.title}
                  </span>
                ); })}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
